// extracted by mini-css-extract-plugin
export default {"titleBarMainHeader":"base-styles_titleBarMainHeader__2p8q8"};